"use strict";

exports.__esModule = true;
exports.default = whitelist;

/**
 * Retourne le tableau trié en gardant les occurances whitelistées.
 * @param {Array} arr
 * @param {object} whitelist
 * @example
 * whitelist(
 *   ["foo", "bar"],
 *   { foo: true }, // signifie que "foo" est blacklisté
 * ); // ["foo"]
 */
function whitelist(arr, whitelist = {}) {
  return arr.filter(function (item) {
    return whitelist[item];
  });
}